import { render } from "./blog-tags-table.vue?vue&type=template&id=036147c8"
import script from "./blog-tags-table.vue?vue&type=script&lang=js"
export * from "./blog-tags-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__